// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { VerticalDetailsGroupViewModel } from '../../../ViewModels/VerticalDetailsGroupViewModel';
import React from 'react';
import { VerticalDetailsItem } from './VerticalDerailsItem';
import ArrowDown from '@styles/webdesktop/Icons/arrowDown.svg';
export class VerticalDetailsGroup extends WMComponent {
    constructor(props) {
        super(props, (VerticalDetailsGroupViewModel));
        this.clickHeader = this.clickHeader.bind(this);
    }
    clickHeader() {
        this.viewModel.changeStateCollapse();
    }
    render() {
        const { groupName, isOpen, visibleGroup, rowItems } = this.state;
        if (!visibleGroup)
            return null;
        const { accountDetailsItemDown, accountDetailsItemMove, accountDetailsItemUp } = this.props;
        return (React.createElement("div", { className: "account-details-group" },
            React.createElement("div", { className: `header-group-container ${!isOpen ? 'collapse' : ''}`, onClick: this.clickHeader },
                React.createElement("div", { className: "group-icon-arrow" },
                    React.createElement(ArrowDown, null)),
                React.createElement("div", { className: "group-name" }, groupName)),
            isOpen && (React.createElement("div", { className: "body-group-container" }, rowItems.map((row, i) => (React.createElement(VerticalDetailsItem, { key: row.getItemId(), row: row, accountDetailsItemDown: accountDetailsItemDown, accountDetailsItemMove: accountDetailsItemMove, accountDetailsItemUp: accountDetailsItemUp })))))));
    }
}
